import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { List } from '@xsolla/ui-core';

import { iconFC } from '../../icons/settings';
import countryData from '../country-data';
import { OptionsWrapper } from './style';

type Props = {
  setCountry: (country: string) => void;
};

export const PhoneOptions = ({ setCountry }: Props): JSX.Element => {
  const intl = useIntl();

  const listItemHandle = (country: string) => {
    setCountry(country);
  };

  const countriesList = useMemo(() => {
    return Object.entries(countryData).reduce(
      (acc, [country, options]) => [
        ...acc,
        {
          children: `${intl.messages[`form.select.country-name.${country}`]} +${options.code}`,
          icon: iconFC[country],
          onClick: () => listItemHandle(country)
        }
      ],
      []
    );
  }, []);

  return (
    <OptionsWrapper>
      <List
        items={countriesList}
        search={{
          emptyMessage: 'Nothing found',
          placeholder: 'Search'
        }}
      />
    </OptionsWrapper>
  );
};
